const minValue = 0
const maxValue = 3

export { minValue, maxValue }
